import { ReadiedRoute, Redirect } from "@itandi/tools/next";
import { Page as Component } from "~/components/specifics/vendors/deals/[id]/inspection_reports/Page";

export function Page() {
	return (
		<ReadiedRoute fallback={<Redirect url="/vendors" />}>
			<Component />
		</ReadiedRoute>
	);
}
